var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 168,
    viewBox: "0 0 432 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 48,
    width: 24,
    height: 24,
    fill: "#6B6158"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    width: 24,
    height: 24,
    fill: "#EFDA1B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 144,
    width: 24,
    height: 24,
    fill: "#68594B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 144,
    width: 24,
    height: 24,
    fill: "#68594B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 168,
    width: 24,
    height: 24,
    transform: "rotate(-180 264 168)",
    fill: "#614329"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 144,
    width: 24,
    height: 24,
    fill: "#68594B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 168,
    width: 24,
    height: 24,
    transform: "rotate(-180 216 168)",
    fill: "#3E2D19"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 168,
    width: 24,
    height: 24,
    transform: "rotate(-180 168 168)",
    fill: "#573D26"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 48,
    width: 24,
    height: 24,
    fill: "#533922"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 96,
    width: 24,
    height: 24,
    fill: "#533922"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E17C18"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    width: 24,
    height: 24,
    fill: "#EFDA1B"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-180 168 24)",
    fill: "#E17C18"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-180 408 24)",
    fill: "#E17C18"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    width: 24,
    height: 24,
    fill: "#EE951D"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 24,
    height: 24,
    fill: "#866242"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 72,
    width: 24,
    height: 24,
    fill: "#503723"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 144,
    width: 24,
    height: 24,
    fill: "#503723"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    y: 120,
    width: 24,
    height: 24,
    fill: "#503723"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 168,
    width: 24,
    height: 24,
    transform: "rotate(-180 144 168)",
    fill: "#614329"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 168,
    width: 24,
    height: 24,
    transform: "rotate(-180 384 168)",
    fill: "#614329"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 144,
    width: 24,
    height: 24,
    fill: "#3E2D19"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-180 216 24)",
    fill: "#EFDA1B"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    width: 24,
    height: 24,
    fill: "#EE951D"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 312,
    width: 24,
    height: 24,
    fill: "#EE951D"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    width: 24,
    height: 24,
    fill: "#E17C18"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    width: 24,
    height: 24,
    fill: "#E17C18"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    width: 24,
    height: 24,
    fill: "#E17C18"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 24,
    width: 24,
    height: 24,
    fill: "#614329"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    y: 144,
    width: 24,
    height: 24,
    fill: "#614329"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    y: 96,
    width: 24,
    height: 24,
    fill: "#614329"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 120,
    width: 24,
    height: 24,
    fill: "#614329"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-180 192 24)",
    fill: "#F8CE01"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    width: 24,
    height: 24,
    fill: "#F8CE01"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 24,
    height: 24,
    fill: "#F8CE01"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-180 144 24)",
    fill: "#F8CE01"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-180 384 24)",
    fill: "#F8CE01"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 408,
    width: 24,
    height: 24,
    fill: "#EE951D"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 144,
    width: 24,
    height: 24,
    fill: "#815F43"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 144,
    width: 24,
    height: 24,
    fill: "#614329"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 144,
    width: 24,
    height: 24,
    fill: "#614329"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 144,
    width: 24,
    height: 24,
    fill: "#614329"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 168,
    width: 24,
    height: 24,
    transform: "rotate(-180 240 168)",
    fill: "#3E2D19"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 168,
    width: 24,
    height: 24,
    transform: "rotate(-180 192 168)",
    fill: "#614329"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 168,
    width: 24,
    height: 24,
    transform: "rotate(-180 432 168)",
    fill: "#68594B"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    y: 72,
    width: 24,
    height: 24,
    fill: "#896241"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.5ed28a04381b220ec36e0196c56469f9.svg";
export { ForwardRef as ReactComponent };